import React,{useEffect,useState} from 'react';
import styled from '@emotion/styled';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';

const TeamContainer = styled.div`
    margin-right:100rem;
    display:grid;
    grid-auto-flow:row;
    width: 72rem;
    color: #505962;
    padding-top: 5rem;
    
    .meet--team--title{
        font-family: Inter, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-40);
        text-align:center;
        color: var(--color-gray-800);
        padding-bottom:4rem;
    }
    .highlight{
        color: var(--company-dark);
        font-weight: 600;
    }
    @media (max-width: 768px){
        .meet--team--title{
            width:60%;
            justify-content:left;
        }
    }
    @media(max-width:500px){
        .meet--team--title{
            width:35%;
            justify-content:left;
            font-size: var(--font-28);
        }
    }
    @media (max-width: 400px){
        .meet--team--title{
            font-size: var(--font-28);
        }
    }
`;

const TeamCarousel = styled.div`
    display: grid;
    grid-auto-flow: column;
    width:100%;
    position:relative;
    .people:nth-of-type(2){
        opacity: 0.5;
    }
    .BrainhubCarousel__dot--selected:before {
    width: 64px !important;
    height: 8px !important;
    background: var(--company-dark) !important;
    }
    .BrainhubCarousel__dot:before {
        width: 64px !important;
        height: 8px !important;
        background: var(--color-gray-400);
        border-radius: 0;
    }
    .BrainhubCarousel__dot:focus {
    outline: none;
    border: 0;
    box-shadow: none !important;
    }
    .nav{
        position:absolute;
        align-self:center;
        left: -2rem;
        top: 30rem;
        z-index: 1;
        cursor:pointer;
        transition: left 0.2s ease-in;
    }
    .nav:hover{
        left:-3.5rem;
    }
    .nav-second{
        position:absolute;
        justify-self:end;
        align-self:center;
        right: -2rem;
        top: 30rem;
        transform: rotate(180deg);
        cursor:pointer;
        transition: right 0.2s ease-in;
    }
    .nav-second:hover{
        right:-3.5rem;
    }
    .team-member--card{
        display: flex;
        flex-direction:column;
        color: #505962;
    }
    .tm--photo{
        border-radius: var(--space-20);
        margin-bottom: 1rem;
    }

    .blur{
        position: absolute;
        height: 28rem;
        width: 20rem;
        z-index: 1;
        right: -5rem;
        background: linear-gradient(90deg,#FFFFFF 81%,rgba(255,255,255,0));
        transform: rotateY(180deg);
    }
    .blur--second{
        position: absolute;
        height: 28rem;
        width: 16rem;
        z-index: 1;
        background: linear-gradient(90deg,#FFFFFF 63%,rgba(255,255,255,0));
    }
    @media(max-width: 800px){
        grid-gap: 4rem;
        .blur{
            position: absolute;
            height: 28rem;
            width: 2rem;
            z-index: 1;
            left: -1rem;
            background: linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)
        }
        .blur--second{
            position: absolute;
            height: 28rem;
            width: 8rem;
            z-index: 1;
            left: 36rem;
            background: linear-gradient(270deg,#FFFFFF 0%,rgba(255,255,255,0) 100%);
        }
        .nav{
            display: none;
        }
        .nav-second{
            display: none;
        }
        .team-member--card:nth-of-type(3){
            opacity:0.25;
        }
    /* // .shadow{
    //     position:absolute;
    //     top:5rem;
    //     left:0;
    //     width:15rem;
    //     height:25rem;
    //     background-color:blue;
    } */
    @media(max-width: 500px){
        .blur{
            position: absolute;
            height: 28rem;
            width: 2rem;
            z-index: 1;
            left: -1rem;
            background: linear-gradient(to right, rgba(255,255,255,1) 15%, rgba(255, 255, 255, 1), 100%);
        }
        .blur--second{
            position: absolute;
            height: 28rem;
            width: 8rem;
            z-index: 1;
            left: 17rem;
            background: linear-gradient(to right, rgba(255,255,255,1) 15%, rgba(255, 255, 255, 1), 100%);
        }
        .team-member--card:nth-of-type(2){
            opacity:0.25;
        }
        .nav-second{
            left:23rem;
        }
    }
    }
`;
const TextContainer = styled.div`
    display:flex;
    flex-direction:column;
    height: 3rem;
    justify-content:space-between;
    .tm--name{
        color: var(--company);
        align-self:center;
        font-weight: 600;
        font-size: 1.3rem;
        margin: 0;
    }
    .tm--position{
        font-size: 1rem;
        font-weight: 600;
        align-self:center;
        margin: 0;
        color: #373B3E;
    }
`;
export default function MeetTheTeam() {

    let array =   [
        {
            photo:'/irad-team/g-munroe.svg',
            name: 'Geene Munroe',
            position: 'Help Desk',
            shadow:'boo'
        },
        {
            photo:'/irad-team/j-homewood.svg',
            name: 'Jonathan Homewood',
            position: 'Inventory Manager',
            shadow:''
        },
        {
            photo:'/irad-team/m-etienne.svg',
            name: 'Maureen Etienne',
            position: 'Chief Financial Officer',
            shadow:''
        },
        {
            photo:'/irad-team/a-martin.svg',
            name: 'Angela Martin',
            position: 'Order Fullfilment',
            shadow:''
        },
        {
            photo:'/irad-team/a-martin.svg',
            name: 'Angela Martin',
            position: 'Order Fullfilment',
            shadow:''
        },
        {
            photo:'/irad-team/a-martin.svg',
            name: 'Angela Martin',
            position: 'Order Fullfilment',
            shadow:''
        },
        {
            photo:'/irad-team/a-martin.svg',
            name: 'Angela Martin',
            position: 'Order Fullfilment',
            shadow:''
        }
    ];

    const [slideIndex, setSlideIndex] = useState(0);
    
    const [teamMembers,setTeamMembers] = useState(array);
 
    return (
        <>
            <TeamContainer>
                <h1 className="meet--team--title">Meet the <span className="highlight"> IRAD </span> Team</h1>
                <TeamCarousel>
                    <div className="blur"/>
                    <div className="blur--second"/>
                    <Carousel
                        slidesPerPage={4}
                        arrowLeft={<img className="nav" src="/irad-team/nav_arrow.svg" alt="navigation button"/>}
                        arrowRight={<img className="nav-second" src="/irad-team/nav_arrow.svg" alt="navigation button"/>}
                        addArrowClickHandler
                        dots
                        infinite
                        className="people"
                    >
                        {teamMembers.map((val,index)=>
                            (
                                <div className="team-member--card" key={index}>
                                    <span><img className="tm--photo" alt="Team Member" src={val.photo} /></span>
                                    <TextContainer>
                                        <p className="highlight tm--name">{val.name}</p>
                                        <p className="tm--position">{val.position}</p>
                                    </TextContainer>
                                </div>
                            )
                        
                        )}
                    </Carousel>
                </TeamCarousel>
            </TeamContainer>
        </>
    );
    
}

const SliderButton = styled.img`
    width: 2rem;
    height: 2rem;
    background-color: #000;
`;

const ButtonContainer = styled.div`
    width: 10rem;
    display: flex;
    justify-content: space-between;
`;

const BtnSlider = ({rightFn, leftFn, right, left}) => {
    return (
        <ButtonContainer>
            <SliderButton onClick={rightFn} src={right}/>
            <SliderButton onClick={leftFn} src={left}/>
        </ButtonContainer>
    );
}